// store/slices/applicationSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ApplicationInterface } from "../../common/types/interfaces";

interface ApplicationState {
  data: ApplicationInterface[];
  loading: boolean;
  error: string | null;
}

const initialState: ApplicationState = {
  data: [],
  loading: false,
  error: null,
};

export const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setApplications: (state, action: PayloadAction<ApplicationInterface[]>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setApplicationsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setApplicationsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    addApplication: (state, action: PayloadAction<ApplicationInterface>) => {
      const exists = state.data.find((a) => a.id === action.payload.id);
      if (!exists) state.data.unshift(action.payload);
    },
    updateApplication: (state, action: PayloadAction<ApplicationInterface>) => {
      const index = state.data.findIndex((a) => a.id === action.payload.id);
      if (index !== -1) state.data[index] = action.payload;
    },
    clearApplications: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setApplications,
  setApplicationsLoading,
  setApplicationsError,
  addApplication,
  updateApplication,
  clearApplications,
} = applicationSlice.actions;

export const selectApplications = (state: RootState) => state.application.data;
export const selectApplicationsLoading = (state: RootState) =>
  state.application.loading;
export const selectApplicationsError = (state: RootState) =>
  state.application.error;

export default applicationSlice.reducer;
